import type { Shop } from '../../types/shop'

/**
 * Inventarios de las tiendas de NPC.
 *
 * VACÍO A PROPÓSITO: los 48 archivos entregados no contienen inventarios de tiendas. El catálogo general de
 * ítems y las tablas de drops NO indican qué vende una tienda, así que no se usan para rellenar esto.
 * Cuando el staff entregue la exportación de las tiendas del servidor, cada tienda se añade aquí con su
 * npcId (id de data/guide/npcs) y sus productos por ID exacto. La guía la muestra automáticamente en la
 * ficha del NPC, en "Dónde conseguirlo" de cada ítem y en el buscador.
 */
export const shops: Shop[] = []

/** Lo que falta para completar NPC y tiendas. Se muestra en la guía como lista concreta. */
export const npcShopPendings: { what: string; detail: string }[] = [
  {
    what: 'Inventarios de todas las tiendas',
    detail: 'Hace falta una exportación nueva del servidor con la relación NPC → tienda → ítem/variante (ID exacto) → nivel → precio y moneda. Aún no se ha entregado ningún archivo de tiendas.',
  },
  {
    what: 'Ubicación y piezas exactas del Robot (805)',
    detail: 'Confirmado por el staff: vende sets de Dark Knight, Dark Wizard, Magic Gladiator y Rage Fighter. Falta: mapa y X/Y, y qué piezas y sets concretos vende, con nivel, precio y moneda.',
  },
  {
    what: 'Ubicación en Vanguard de Hanzo the Blacksmith (251), Pasi the Mage (254), Elf Lala (242) y Eo the Craftsman (243)',
    detail: 'Los archivos no traen su posición permanente. Se muestra el mapa de la referencia clásica, pendiente de validar. Falta mapa y X/Y confirmados por administración.',
  },
  {
    what: 'Servicios de cada NPC en Vanguard',
    detail: 'Venta, reparación y mejoras se muestran como función clásica de Season 6. Falta confirmar cuáles presta cada NPC en Vanguard.',
  },
  {
    what: 'Resto de NPC de otros mapas',
    detail: 'Devias, Dungeon, Atlans, Lost Tower, Tarkan, Elbeland y demás: falta la lista de NPC con su ID, ubicación y función.',
  },
]
